module.exports = __webpack_public_path__ + "img/top_slider_202504_birthdaycampaign.c1f77e2b.jpg";